const query = (itemIds) => {
  return `
      query {
        items(ids: [${itemIds.join(',')}]) {
          id,
          name,
          board {
            id,
            name,
          },
          column_values {
            id,
            type,
            value,
            text,
            title
          }
        }
      }
  `;
};

export default query;
